import http from "./axios";

// let userState = 'userState';
// let normalUrl = 'api'; //普通啥也不加的
// let baseUrl = 'maketApi'; //外网开发，跨域用这个--上市公司
// let medicineUrl = 'medicineApi'; //医药公司
// window.baseUrl = 'marketApi';
// window.normalUrl = 'api';
// window.medicineUrl = 'medicineApi';

let normalUrl = "/tentapi"; //上线前放开--啥也不加的
window.normalUrl = "/tentapi";
let baseUrl = "/tentapi/list"; //上线前放开
let medicineUrl = "/tentapi/medicine"; //上线前放开
window.baseUrl = "/tentapi/list"; //上线前放开
window.medicineUrl = "/tentapi/medicine"; //上线前放开
let userState = "https://user.drcnet.com.cn/userapi"; //上线前放开
export default {
  //上市公司筛选部分--------
  upmarketsearchMarket(searchName) {
    //搜索股票联想接口
    return http(
      "get",
      normalUrl +
        "/list/listCcompany/getRecentFiveInfoByName?searchName=" +
        searchName,
      "json"
    );
  },
  upmarketsearchTree() {
    //搜索股票联想接口
    return http(
      "get",
      normalUrl + "/list/listCcompany/getStockSearchAllClass",
      "json"
    );
  },
  upmarketsearchById(searchParam) {
    //点击树形图获取可选股票
    return http(
      "get",
      normalUrl +
        "/list/listCcompany/getStocksBySearchId?searchParam=" +
        searchParam,
      "json"
    );
  },
  upmarketsearchTextSelect() {
    //选择字段--下拉框数据获取
    return http("get", normalUrl + "/list/listCcompany/getSearchData", "json");
  },
  upmarketsearchTextSelectTime(dataCode) {
    //选择字段--下拉框季度获取数据
    return http(
      "get",
      normalUrl + "/list/listCcompany/getReportDate?dataCode=" + dataCode,
      "json"
    );
  },
  upmarketsearchTextGetList(dataCode) {
    //选择字段--获取可选股票
    return http(
      "get",
      normalUrl + "/list/listCcompany/getIndicatorByCoder?dataCode=" + dataCode,
      "json"
    );
  },
  upmarketsearchAllBtn(data) {
    //选择字段--获取可选股票
    return http(
      "post",
      normalUrl + "/list/listCcompany/getIndicatorByCoder",
      "json",
      data
    );
  },
  // -------------------------股本股东------------------
  // 股本股东--股本
  stockStructure(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/capitalStructure/getCapitalStructureData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // 股本股东--主要
  stockMajor(stockCode, enterpriseCode, endDate) {
    return http(
      "get",
      normalUrl +
        "/list/capitalStructure/getEquityMajorData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&endDate=" +
        endDate,
      "json"
    );
  },
  // 股本股东--主要流通
  stockCirculate(stockCode, enterpriseCode, endDate) {
    return http(
      "get",
      normalUrl +
        "/list/capitalStructure/geTequityLiquidityData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&endDate=" +
        endDate,
      "json"
    );
  },
  // 股本股东--基金持股
  stockFund(parmars) {
    return http(
      "post",
      normalUrl + "/list/capitalStructure/geEquityFundData",
      "json",
      parmars
    );
  },
  // 股本股东--高管持股
  stockExecutive(parmars) {
    return http(
      "post",
      normalUrl + "/list/capitalStructure/geExecutiveStockData",
      "json",
      parmars
    );
  },
  // 股本股东--内部持股变动
  stockInside(parmars) {
    return http(
      "post",
      normalUrl + "/list/capitalStructure/geEquityChangesData",
      "json",
      parmars
    );
  },
  // 股本股东--限售解禁
  stockSell(parmars) {
    return http(
      "post",
      normalUrl + "/list/capitalStructure/getEquityRestrictionData",
      "json",
      parmars
    );
  },

  // 股本股东--主要--截止日期
  stockMajorDate(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/capitalStructure/getEquityMajorDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // 股本股东--主要流通--截止日期
  stockCirculateDate(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/capitalStructure/geTequityLiquidityDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },

  // 股本股东--基金持股--截止日期
  stockFundDate(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/capitalStructure/geEquityFundDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // 下载
  // 股本股东--股本--下载
  stockStructureDown(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/capitalStructure/downCapitalStructureData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      { responseType: "blob" }
    );
  },

  // 股本股东--股东总趋势
  stockMajorAll(stockCode, enterpriseCode, endDate) {
    return http(
      "get",
      normalUrl +
        "/list/capitalStructure/getEquityMajorTrends?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&endDate=" +
        endDate,
      "json"
    );
  },
  // 股本股东--股东平均趋势
  stockMajorBalance(stockCode, enterpriseCode, endDate) {
    return http(
      "get",
      normalUrl +
        "/list/capitalStructure/getEquityMajorAverage?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&endDate=" +
        endDate,
      "json"
    );
  },
  // ------------------------------财务分析--------------------
  // ----每股指标
  analyzeNorm(parmars) {
    return http(
      "post",
      normalUrl + "/list/financialAnalysis/getPerShareIndexData",
      "json",
      parmars
    );
  },
  // -------矩形图--每股收益
  analyzeNormRevenue(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getEarnPerShareData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // -------矩形图--每股净资产报表
  analyzeNormAsset(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getPerShareEarnData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },

  // ----盈利能力
  analyzeGain(parmars) {
    return http(
      "post",
      normalUrl + "/list/financialAnalysis/getProfitabilityData",
      "json",
      parmars
    );
  },
  // -------矩形图--营业利润率报表
  analyzeGainOpen(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getOperatePprofitMarginData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // -------矩形图--净资产收益率
  analyzeGainWorth(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getReturnRateData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },

  // ----偿还能力
  analyzeRepay(parmars) {
    return http(
      "post",
      normalUrl + "/list/financialAnalysis/getRepaymentAbilityData",
      "json",
      parmars
    );
  },
  // -------矩形图--流动比率
  analyzeRepayFlow(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getLiquidityRatioData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },

  // -------矩形图--资产负债率
  analyzeRepayDebt(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getAssetLiabilityRatioData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },

  // ----成长能力
  analyzeGrowth(parmars) {
    return http(
      "post",
      normalUrl + "/list/financialAnalysis/getGrowthAbilityData",
      "json",
      parmars
    );
  },

  // -------矩形图--净利润增长率
  analyzeGrowthProfit(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getProfitGrowthData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // -------矩形图--净资产增长率
  analyzeGrowthAsset(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getAssetGrowthData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },

  // ----营运能力
  analyzeOperate(parmars) {
    return http(
      "post",
      normalUrl + "/list/financialAnalysis/getOperationalCapabilityData",
      "json",
      parmars
    );
  },
  // -------矩形图--存货周转率（次）
  analyzeOperateInventory(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getInventoryTurnoverData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // -------矩形图--总资产周转率（次）
  analyzeOperateAsset(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getAssetTurnoverData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },

  // -------杜邦分析---日期
  analyzeDupontDate(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getDuPontDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // ----杜邦分析---图
  analyzeDupont(parmars) {
    return http(
      "post",
      normalUrl + "/list/financialAnalysis/getDuPontData",
      "json",
      parmars
    );
  },
  // -------帕利普分析---日期
  analyzePalepuDate(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getPalipDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // ----帕利普分析---图
  analyzePalepu(parmars) {
    return http(
      "post",
      normalUrl + "/list/financialAnalysis/getPalipData",
      "json",
      parmars
    );
  },
  // -------Z-分数---日期
  analyzeZscoreDate(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getZscoreDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // ----Z-分数---图
  analyzeZscore(parmars) {
    return http(
      "post",
      normalUrl + "/list/financialAnalysis/getZscoreData",
      "json",
      parmars
    );
  },
  // -------F-分数---日期
  analyzeFscoreDate(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getFscoreDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // ----F-分数---图
  analyzeFscore(parmars) {
    return http(
      "post",
      normalUrl + "/list/financialAnalysis/getFscoreData",
      "json",
      parmars
    );
  },
  // -------巴萨利分数--日期
  analyzeBazhoryDate(stockCode, enterpriseCode) {
    return http(
      "get",
      normalUrl +
        "/list/financialAnalysis/getBasaliScoreDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  // ----巴萨利分数--图
  analyzeBazhory(parmars) {
    return http(
      "post",
      normalUrl + "/list/financialAnalysis/getBasaliScoreData",
      "json",
      parmars
    );
  },
  //以上是搜索部分接口------
  upmarketAllCount() {
    //上市公司总数
    return http(
      "get",
      normalUrl + "/list/listCcompany/getListedCompaniesStatistics",
      "json"
    );
  },
  upmarketMap() {
    return http(
      "get",
      normalUrl + "/list/listCcompany/getListedAreaStatistics",
      "json"
    );
  },
  upmarketTimeNum() {
    return http(
      "get",
      normalUrl + "/list/listCcompany/getListedTimeStatistics",
      "json"
    );
  },
  upmarketworkNum() {
    //上市公司行业分布情况
    return http(
      "get",
      normalUrl + "/list/listCcompany/getListedCsrcStatistics",
      "json"
    );
  },
  upmarketImgOne() {
    //上海证券交易所
    return http(
      "get",
      normalUrl + "/list/listCcompany/getShangZhenStatistics",
      "json"
    );
  },
  upmarketImgTwo() {
    //深圳证券交易所
    return http(
      "get",
      normalUrl + "/list/listCcompany/getShenZhenStatistics",
      "json"
    );
  },

  //公司基本信息部分
  baseInfoTable(stockCode, enterpriseCode) {
    //公司简介
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/getCompanyProfile?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  baseInfoTableOne(stockCode, enterpriseCode, incomeType, reportDate) {
    //收入构成
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/getIncomeData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&incomeType=" +
        incomeType +
        "&reportDate=" +
        reportDate,
      "json"
    );
  },
  baseInfoTableOneTime(stockCode, enterpriseCode, incomeType) {
    //收入构成--时间选项
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/getIncomeReportDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&incomeType=" +
        incomeType,
      "json"
    );
  },
  baseInfoTableDown(stockCode, enterpriseCode, incomeType, reportDate) {
    //收入构成--下载函数
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/downIncomeData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&incomeType=" +
        incomeType +
        "&reportDate=" +
        reportDate,
      "json"
    );
  },
  baseInfoTableTwo(stockCode, enterpriseCode, executivesType, sessionNum) {
    //公司高管
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/getExecutivesData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&executivesType=" +
        executivesType +
        "&sessionNum=" +
        sessionNum,
      "json"
    );
  },
  baseInfoTableTwoTime(stockCode, enterpriseCode, executivesType) {
    //公司高管--时间选项
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/getexecutivesSession?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&executivesType=" +
        executivesType,
      "json"
    );
  },
  baseInfoTableTwoDown(stockCode, enterpriseCode, sessionDNum, sessionJNum) {
    //公司高管--下载函数
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/downExecutivesData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&sessionDNum=" +
        sessionDNum +
        "&sessionJNum=" +
        sessionJNum,
      "json"
    );
  },
  baseInfoTableThree(stockCode, enterpriseCode, staffClassType, reportDate) {
    //员工构成
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/getStaffData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&staffClassType=" +
        staffClassType +
        "&reportDate=" +
        reportDate,
      "json"
    );
  },
  baseInfoTableThreeTime(stockCode, enterpriseCode, staffClassType) {
    //员工构成--时间选项
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/getStaffReportDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&staffClassType=" +
        staffClassType,
      "json"
    );
  },
  baseInfoTableCompanyDetail(creditCode) {
    //获取企业共有哪些股票的详细信息
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/getInfoByCreditCode?creditCode=" +
        creditCode,
      "json"
    );
  },
  getPersonInfoFn(stockCode, enterpriseCode, persionCode) {
    //获取个人信息接口
    return http(
      "get",
      normalUrl +
        "/list/companyBasic/getExecutiveInfo?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&persionCode=" +
        persionCode,
      "json"
    );
  }, //发行分配部分
  distriGetPay(params) {
    //分红情况
    return http(
      "post",
      normalUrl + "/list/capitalStructure/getProfitShareData",
      "json",
      params
    );
  },
  distriAddMore(params) {
    //增发数据
    return http(
      "post",
      normalUrl + "/list/capitalStructure/getStockIssuanceData",
      "json",
      params
    );
  },
  distriNewMarket(stockCode, enterpriseCode) {
    //新股发行
    return http(
      "get",
      normalUrl +
        "/list/capitalStructure/getStockFirstData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  distriShareMarket(params) {
    //配股情况
    return http(
      "post",
      normalUrl + "/list/capitalStructure/getAssignStockData",
      "json",
      params
    );
  },
  distriMarketPlan(params) {
    //历年融资计划
    return http(
      "post",
      normalUrl + "/list/capitalStructure/getFinancingPlanData",
      "json",
      params
    );
  },
  //财务数据部分
  financeInfoOne(params) {
    //财务摘要表
    return http(
      "post",
      normalUrl + "/list/financialData/getSummaryStatementData",
      "json",
      params
    );
  },
  liabilitiesOne(params) {
    //资产负债表
    return http(
      "post",
      normalUrl + "/list/financialData/getAssetDebtData",
      "json",
      params
    );
  },
  cashCountOne(params) {
    //现金流量表
    return http(
      "post",
      normalUrl + "/list/financialData/getCashFlowData",
      "json",
      params
    );
  },
  profitOne(params) {
    //利润表
    return http(
      "post",
      normalUrl + "/list/financialData/getShProfiData",
      "json",
      params
    );
  },
  marketRightsOne(stockCode, enterpriseCode) {
    //股东权益增减
    return http(
      "get",
      normalUrl +
        "/list/financialData/getRightsFluctuateData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  forecastPredictOne(stockCode, enterpriseCode, reportDate) {
    //业绩预告
    return http(
      "get",
      normalUrl +
        "/list/financialData/getPerformanceForecastData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&reportDate=" +
        reportDate,
      "json"
    );
  },
  forecastPredictTimeOne(stockCode, enterpriseCode) {
    //业绩预告
    return http(
      "get",
      normalUrl +
        "/list/financialData/getPerformanceForecastDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  //资本运作部分
  participantOne(params) {
    //参股券商
    return http(
      "post",
      normalUrl + "/list/capitalOperation/getEquityBrokeragesData",
      "json",
      params
    );
  },
  participantTimeOne(stockCode, enterpriseCode) {
    //参股券商时间数据
    return http(
      "get",
      normalUrl +
        "/list/capitalOperation/getEquityBrokerageDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  controllersOne(params) {
    //参股控股
    return http(
      "post",
      normalUrl + "/list/capitalOperation/getHoldingSharesData",
      "json",
      params
    );
  },
  controllersTimeOne(stockCode, enterpriseCode) {
    //控股参股时间数据
    return http(
      "get",
      normalUrl +
        "/list/capitalOperation/getHoldingSharesDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  exchangeOne(params) {
    //资产置换
    return http(
      "post",
      normalUrl + "/list/capitalOperation/getAssetReplacementData",
      "json",
      params
    );
  },
  exchangeTimeOne(stockCode, enterpriseCode) {
    //资产置换时间数据
    return http(
      "get",
      normalUrl +
        "/list/capitalOperation/getAssetReplacementDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  transactionsOne(params) {
    //资产交易
    return http(
      "post",
      normalUrl + "/list/capitalOperation/getAssetTradeData",
      "json",
      params
    );
  },
  transactionsTimeOne(stockCode, enterpriseCode) {
    //资产交易时间数据
    return http(
      "get",
      normalUrl +
        "/list/capitalOperation/getAssetTradeDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  divestitureOne(params) {
    //资产剥离
    return http(
      "post",
      normalUrl + "/list/capitalOperation/getAssetStrippeData",
      "json",
      params
    );
  },
  divestitureTimeOne(stockCode, enterpriseCode) {
    //资产剥离时间数据
    return http(
      "get",
      normalUrl +
        "/list/capitalOperation/getAssetStrippeDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  //重大事项部分
  pledgeOne(params) {
    //股权质押--质押比例
    return http(
      "post",
      normalUrl + "/list/matters/getZyblData",
      "json",
      params
    );
  },
  pledgeTwo(params) {
    //股权质押--重要股东统计
    return http(
      "post",
      normalUrl + "/list/matters/getZygdtjData",
      "json",
      params
    );
  },
  pledgeThree(params) {
    //股权质押--质押明细
    return http(
      "post",
      normalUrl + "/list/matters/getZymxData",
      "json",
      params
    );
  },
  reorganizationOne(params) {
    //并购重组
    return http(
      "post",
      normalUrl + "/list/matters/getBgczData",
      "json",
      params
    );
  },
  reorganizationDetailOne(bgczCode) {
    //并购重组--详情页
    return http(
      "get",
      normalUrl + "/list/matters/getBgczDetail?bgczCode=" + bgczCode,
      "json"
    );
  },
  meetingnoticeOne(stockCode, enterpriseCode, announcementDate) {
    //股东大会通知
    return http(
      "get",
      normalUrl +
        "/list/matters/getMeetingNoticeData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&announcementDate=" +
        announcementDate,
      "json"
    );
  },
  meetingnoticeTimeOne(stockCode, enterpriseCode) {
    //股东大会通知时间
    return http(
      "get",
      normalUrl +
        "/list/matters/getMeetingNoticeDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  violationOne(stockCode, enterpriseCode, announcementDate) {
    //违规记录
    return http(
      "get",
      normalUrl +
        "/list/matters/getViolationRecordData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&announcementDate=" +
        announcementDate,
      "json"
    );
  },
  violationTimeOne(stockCode, enterpriseCode) {
    //违规记录时间
    return http(
      "get",
      normalUrl +
        "/list/matters/getViolationRecordDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  arbitrationOne(stockCode, enterpriseCode, announcementDate) {
    //诉讼仲裁
    return http(
      "get",
      normalUrl +
        "/list/matters/getLitigationArbitrationData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&announcementDate=" +
        announcementDate,
      "json"
    );
  },
  arbitrationTimeOne(stockCode, enterpriseCode) {
    //诉讼仲裁时间
    return http(
      "get",
      normalUrl +
        "/list/matters/getLitigationArbitrationDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  guaranteeOne(stockCode, enterpriseCode, announcementDate) {
    //对外担保
    return http(
      "get",
      normalUrl +
        "/list/matters/getExternalGuaranteeData?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode +
        "&announcementDate=" +
        announcementDate,
      "json"
    );
  },
  guaranteeTimeOne(stockCode, enterpriseCode) {
    //对外担保时间
    return http(
      "get",
      normalUrl +
        "/list/matters/getExternalGuaranteeDate?stockCode=" +
        stockCode +
        "&enterpriseCode=" +
        enterpriseCode,
      "json"
    );
  },
  //公告部分
  announcementTimeOne() {
    //公司公告时间
    return http("get", normalUrl + "/list/notice/getAnnouncementType", "json");
  },
  announcementOne(params) {
    //公司公告
    return http(
      "post",
      normalUrl + "/list/notice/getCompanyNoticeData",
      "json",
      params
    );
  },
  cinformationOne(params) {
    //公司资讯
    return http(
      "post",
      normalUrl + "/list/notice/getCompanyInforData",
      "json",
      params
    );
  },
  hinformationOne(params) {
    //行业资讯
    return http(
      "post",
      normalUrl + "/list/notice/getCompanyHyzxData",
      "json",
      params
    );
  },

  //登录部分
  getloginKey() {
    //获取加密公钥
    return http("get", normalUrl + "/login/getLoginKey", "json");
  },
  gologin(loginId, password, hashKey, guid) {
    //登录
    return http(
      "get",
      normalUrl +
        "/login/login?loginId=" +
        loginId +
        "&password=" +
        password +
        "&hashKey=" +
        hashKey +
        "&guid=" +
        guid,
      "json"
    );
  },
  unlogin(guid) {
    //退出登录
    return http("get", normalUrl + "/login/loginOut?guid=" + guid, "json");
  },
  iflogin(guid) {
    //判断是否已登录
    return http(
      "get",
      userState + "/loginController/initLogin?guid=" + guid,
      "json"
    );
  },
  weighterRights(productId) {
    //判断是否有权限
    return http(
      "get",
      normalUrl + "/authority/getAuthor?productId=" + productId,
      "json"
    );
  },
  // storeupList(params) { //收藏页列表获取
  //     return http('post', normalUrl + '/list/collectCompany/getCollectCompany', 'json', params);
  // },
  // deleteStoreup(params) { //取消收藏
  //     return http('post', normalUrl + '/list/collectCompany/cancelCollectCompany', 'json', params);
  // },
  // addStoreup(params) { //添加收藏
  //     return http('post', normalUrl + '/list/collectCompany/collectCompany', 'json', params);
  // },
  storeupList(params) {
    //收藏页列表获取
    return http(
      "post",
      normalUrl + "/business/collectCompany/getCollectCompany",
      "json",
      params
    );
  },
  deleteStoreup(params) {
    //取消收藏
    return http(
      "post",
      normalUrl + "/business/collectCompany/cancelCollectCompany",
      "json",
      params
    );
  },
  addStoreup(params) {
    //添加收藏
    return http(
      "post",
      normalUrl + "/business/collectCompany/collectCompany",
      "json",
      params
    );
  },
  isStoreup(params) {
    //是否收藏
    return http(
      "post",
      normalUrl + "/business/collectCompany/checkCollect",
      "json",
      params
    );
  },
  ifStoreup(params) {
    //判断当前股票的收藏状态
    return http(
      "post",
      normalUrl + "/list/collectCompany/checkCollect",
      "json",
      params
    );
  },
  checkExistBussiness(params) {
    //检测是否有工商数据
    return http(
      "post",
      normalUrl + "/index/checkExistBussiness",
      "json",
      params
    );
  },

  // ----------------------------首页----------------------------

  // 首页--搜索
  indexSearch(companyName) {
    return http(
      "get",
      normalUrl +
        "/list/companySearch/getFiveCompany?companyName=" +
        companyName,
      "json"
    );
  },
  downCompanyData(params) {
    return http("post", normalUrl + "/index/downCompanyData", "json", params);
  },

  // header-title
  getIndexTitle() {
    return http("get", normalUrl + "/index/getIndexTitle", "json");
  },
  //首页-数据实时总量
  getTotalCount() {
    return http("get", normalUrl + "/index/getIndexTotalCount", "json");
  },
  //首页-高级查询条件
  getSearchData() {
    return http("get", normalUrl + "/index/getQueryDictsTemp", "json");
  },
  // 检索页-----daigai
  searchPage(parmars) {
    return http(
      "post",
      baseUrl + "/companySearch/getCompanyData",
      "json",
      parmars
    );
  },
  //检索页 -- 推荐
  getCompanyHits(size) {
    return http(
      "get",
      normalUrl + "/index/getCompanyHits?size=" + size,
      "json"
    );
  },
  getCompanyData(params) {
    // 检索页---检索接口
    return http("post", normalUrl + "/index/getCompanyData", "json", params);
  },

  // ------------------------------------医药公司---------------------------------
  // -------圆环图--医药进出口           待改
  // pharmaSumCake() {
  //     return http('get', medicineUrl + '/medicineSearch/getTypeStatistics', 'json');
  // },

  // -------圆环图--医药进出口
  pharmaSumCake() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getTypeStatistics",
      "json"
    );
  },
  // -------中国地图--医药进出口
  pharmaSumMap() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getRegionStatistics",
      "json"
    );
  },
  // --------时间--医药进出口
  pharmaAmountTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getImexportMoneyTime",
      "json"
    );
  },
  // --------大类--医药进出口
  pharmaAmountType() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getImexportMoneyType",
      "json"
    );
  },
  // -------表格--医药进出口
  pharmaAmountTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getImexportMoneyData",
      "json",
      parmars
    );
  },

  // -------表格----------主要品种产量------------化学制剂
  pharmaChemicalMajorTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getDrugOutputData",
      "json",
      parmars
    );
  },

  // 化学药品制剂主要品种产量-------时间
  pharmaChemicalMajorTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getDrugOutputTime",
      "json"
    );
  },
  // 化学药品制剂主要品种产量-分类1
  pharmaChemicalMajorTypeOne() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getDrugOutputTypeOne",
      "json"
    );
  },
  // 化学药品制剂主要品种产量-分类2
  pharmaChemicalMajorTypeTwo() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getDrugOutputTypeTwo",
      "json"
    );
  },
  // -------表格----------进出口数量-------------医药进出口
  pharmaTradingAmountTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getImexportAmountData",
      "json",
      parmars
    );
  },
  // 进出口数量-------时间
  pharmaTradingAmountTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getImexportAmountTime",
      "json"
    );
  },

  // 进出口数量------商品大类
  pharmaTradingAmountType() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getImexportAmountType",
      "json"
    );
  },
  // -------表格----------批准新药-------------批准新药情况
  pharmaNewDrugsTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getDrugData",
      "json",
      parmars
    );
  },
  // 批准新药-------时间
  pharmaNewDrugsTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getDrugTime",
      "json"
    );
  },

  // 批准新药-------分类
  pharmaNewDrugsType() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getDrugType",
      "json"
    );
  },

  // 批准新药-------剂型
  pharmaNewDrugsForm() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getDrugForm",
      "json"
    );
  },

  // -------表格----------中间体品种产量------------化学制剂
  pharmaMidbodyTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getIntermediateData",
      "json",
      parmars
    );
  },

  // 中间体品种产量-------时间
  pharmaMidbodyTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getIntermediateTime",
      "json"
    );
  },

  // -------表格----------二十四大类品种产量、出口量------------化学制剂
  pharmaTwentyFourTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getEnterprise24Data",
      "json",
      parmars
    );
  },

  // 二十四大类品种产量、出口量--------时间
  pharmaTwentyFourTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getEnterprise24Time",
      "json"
    );
  },
  // 二十四大类品种产量、出口量--------品种
  pharmaTwentyFourType() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getEnterprise24Type",
      "json"
    );
  },

  // -------表格----------中药生物制药主要品种产量------------中药生物
  pharmaChineseMedicineTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getChinesemedicineData",
      "json",
      parmars
    );
  },
  // 中药生物制药主要品种产量--------时间
  pharmaChineseMedicineTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getChinesemedicineTime",
      "json"
    );
  },
  // 中药生物制药主要品种产量--------类型1
  pharmaChineseMedicineType1() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getChinesemedicineTypeOne",
      "json"
    );
  },
  //中药生物制药主要品种产量--------类型2
  pharmaChineseMedicineType2() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getChinesemedicineTypeTwo",
      "json"
    );
  },
  // -------表格----------医药器械主要品种产量------------医药器械
  pharmaInstrumentTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getInstrumentData",
      "json",
      parmars
    );
  },
  // 医药器械主要品种产量--------时间
  pharmaInstrumentTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getInstrumentTime",
      "json"
    );
  },
  // -------表格----------CFDA批准的境内第三医疗器械------------医药器械
  pharmaThirdlyTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getCfdaData",
      "json",
      parmars
    );
  },
  // CFDA批准的境内第三医疗器械--------年份
  pharmaThirdlyTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getCfdaTime",
      "json"
    );
  },
  // -------表格----------主要城市重点医院用药品种金额排序------------医院用药
  pharmaEmphasisTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getDrugOrderbyData",
      "json",
      parmars
    );
  },
  // 主要城市重点医院用药品种金额排序--------年份
  pharmaEmphasisTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getDrugOrderbyTime",
      "json"
    );
  },
  // -------表格----------医药企业名录-------------医药企业
  pharmaDrugFormTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getEnterprisesData",
      "json",
      parmars
    );
  },
  // 医药企业名录-------时间
  pharmaDrugFormTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getEnterprisesTime",
      "json"
    );
  },

  // 医药企业名录-------类别
  pharmaDrugFormType() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getEnterprisesType",
      "json"
    );
  },

  // 医药企业名录-------地区
  pharmaDrugFormRegions() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getEnterprisesRegion",
      "json"
    );
  },
  // -------表格----------通过《药品生产质量管理规范》认证的企业------------医药企业
  pharmaStandardTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getCertifiedEnterpriseData",
      "json",
      parmars
    );
  },
  // 通过《药品生产质量管理规范》认证的企业--------时间
  pharmaStandardTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getCertifiedEnterpriseTime",
      "json"
    );
  },

  // -------表格----------通过制剂国际认证的企业-------------医药企业
  pharmaInternationalTable(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineSearch/getCertifiedData",
      "json",
      parmars
    );
  },
  // 通过制剂国际认证的企业-------时间
  pharmaInternationalTime() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getCertifiedTime",
      "json"
    );
  },
  // 通过制剂国际认证的企业------认证类型
  pharmaInternationalType() {
    return http(
      "get",
      normalUrl + "/medicine/medicineSearch/getCertifiedType",
      "json"
    );
  },
  //   全部的
  entireGetData(parmars) {
    return http(
      "post",
      normalUrl + "/medicine/medicineShow/getShowData",
      "json",
      parmars
    );
  },
  // -------工业数据-------
  getIndustryOrRegionMap(type, year) {
    // 获取工业echarts数据
    return http(
      "get",
      normalUrl +
        "/IndustrialVisualViewController/getIndustryOrRegionMap?type=" +
        type +
        "&year=" +
        year,
      "json"
    );
  },
  getIndustrialDimensions() {
    // 条件查询获取工业数据维度列表
    return http(
      "get",
      normalUrl + "/IndustrialVisualViewController/getIndustrialDimensions",
      "json"
    );
  },
  getIndustryDataDetail(params) {
    // 条件查询获取工业数据详情
    return http(
      "get",
      normalUrl + "/IndustrialVisualViewController/getIndustryDataDetail",
      "json",
      params
    );
  },
  //------海关数据------
  getPicDataByNames(type, year, iore) {
    // 获取海关echarts数据
    return http(
      "get",
      normalUrl +
        "/HaiGuanVisualViewController/getPicDataByNames?typeName=" +
        type +
        "&yearName=" +
        year +
        "&ioreName=" +
        iore,
      "json"
    );
  },
  getHaiGuanDimensions() {
    // 条件查询获取海关数据维度列表
    return http(
      "get",
      normalUrl + "/HaiGuanVisualViewController/getHaiGuanDimensions",
      "json"
    );
  },
  getHaiGuanDataDetail(params) {
    // 条件查询获取海关数据详情
    return http(
      "get",
      normalUrl + "/HaiGuanVisualViewController/getHaiGuanDataDetail",
      "json",
      params
    );
  },

  // ------ 企业画像 ------

  //第一次点击获取前5个标签数据
  getBusinessFirstShowData(params) {
    return http(
      "post",
      normalUrl + "/index/getBusinessFirstShowData",
      "json",
      params
    );
  },
  //推荐企业
  getRecommendCompany(params) {
    return http(
      "post",
      normalUrl + "/index/getRecommendCompany",
      "json",
      params
    );
  },
  //获取标签
  getBusinessLabel(params) {
    return http("post", normalUrl + "/index/getBusinessLabel", "json", params);
  },
  //获取指定标签数据
  getBusinessLabelShowData(params) {
    return http(
      "post",
      normalUrl + "/index/getBusinessLabelShowData",
      "json",
      params
    );
  },
  //获取Title
  getBusinessTitle(params) {
    return http("post", normalUrl + "/index/getBusinessTitle", "json", params);
  },
  //  裁判文书
  //获取裁判文书时间轴
  getTimes() {
    return http("get", normalUrl + "/wenshu/getTimes ", "json");
  },
  //获取裁判文书筛选条件
  getQueryData() {
    return http("get", normalUrl + "/wenshu/getQueryData", "json");
  },
  //获取案由下一级
  getNextCasereason(parentCasereasonId) {
    return http(
      "get",
      normalUrl +
        "/wenshu/getNextCasereason?parentCasereasonId=" +
        parentCasereasonId,
      "json"
    );
  },
  //裁判文书可视化
  getWenshuShowData(params) {
    return http(
      "post",
      normalUrl + "/wenshu/getWenshuShowData",
      "json",
      params
    );
  },
  //裁判文书搜索
  getWenshuSearchData(params) {
    return http(
      "post",
      normalUrl + "/wenshu/getWenshuSearchData",
      "json",
      params
    );
  },
  //裁判文书详情
  getWenshuDetail(params) {
    return http("post", normalUrl + "/wenshu/getWenshuDetail", "json", params);
  },
  // 产业地图部分
  imap_getTreeData() {
    return http("get", normalUrl + "/industryMap/getQuerys ", "json");
  },
  imap_getNextIndustryDot(parentIndustryId) {
    //获取下一节点的所属行业
    return http(
      "get",
      normalUrl +
        "/base/getNextIndustryData?parentIndustryId=" +
        parentIndustryId,
      "json"
    );
  },
  getNextRegionData(parentRegionId) {
    //获取下一节点的登记城市
    return http(
      "get",
      normalUrl + "/base/getNextRegionData?parentRegionId=" + parentRegionId,
      "json"
    );
  },
  imap_getMapData(params) {
    //产业地图获取地图数据
    return http("post", normalUrl + "/industryMap/getMapData", "json", params);
  },
  imap_getBarData(params) {
    //产业地图获取柱状图数据
    return http(
      "post",
      normalUrl + "/industryMap/getBarChartData",
      "json",
      params
    );
  },

  // -----首页开放平台列表-----
  getPlatformTitle() {
    return http("get", normalUrl + "/index/getPlatformTitle", "json");
  },
  // 迁徙分析
  mmap_getDevelopData(params) {
    return http(
      "post",
      normalUrl + "/migration/getMigrationData",
      "json",
      params
    );
  },
  // 发展概况
  dmap_getAllData(params) {
    return http(
      "post",
      normalUrl + "/development/getDevelopData",
      "json",
      params
    );
  },

  // ------政府采购部分----------------------
  getOrderOrRegionMap(params) {
    // 获取政府采购echarts数据
    return http("post", normalUrl + "/zfcg/getZfcgShowData", "json", params);
  },
  //获取政府采购时间轴
  getCpanTimes() {
    return http("get", normalUrl + "/zfcg/getTimes ", "json");
  },
  //获取政府采购筛选条件
  cpws_getQueryData() {
    return http("get", normalUrl + "/zfcg/getQueryData", "json");
  },
  //获取类目下一级
  cpws_getNextCasereason(parentItemId) {
    return http(
      "get",
      normalUrl + "/zfcg/getNextItem?parentItemId=" + parentItemId,
      "json"
    );
  },
  //政府采购搜索
  cpws_getWenshuSearchData(params) {
    return http("post", normalUrl + "/zfcg/getZfcgSearchData", "json", params);
  },
  //政府采购详情
  cpws_getWenshuDetail(contentKey) {
    return http(
      "get",
      normalUrl + "/zfcg/getZfcgContent?contentKey=" + contentKey,
      "json"
    );
  },

  //判断政府采购详情是否有数据
  cpws_ifWenshuDetail_has(contentKey) {
    return http(
      "get",
      normalUrl + "/zfcg/getZfcgDeatilFlag?contentKey=" + contentKey,
      "json"
    );
  },
};



// WEBPACK FOOTER //
// ./static/common/api/api.js